export function phProcessData(dataArray) {
    const phLabels = [];
    const phLowerLimit = [];
    const phHigherLimit = [];
    const phControlLine = [];
    const phData = [];
    const coolantData = [];

  
    dataArray.forEach(item => {
      // Push water_ph to phLabels
      phLabels.push(item?.machine_charged_date);
  
      // Find the highest value in conc_limit_lower and push to phLowerLimit
      const highestLowerLimit = Math.max(...item?.conc_limit_lower);
      phLowerLimit.push(highestLowerLimit);
  
      // Find the highest value in conc_limit_higher and push to phHigherLimit
      const highestHigherLimit = Math.max(...item?.conc_limit_higher);
      phHigherLimit.push(highestHigherLimit);
  
      // Push conc_perc_after to phControlLine
      phControlLine.push(item?.conc_perc_after);

      //Push water_ph to phData
      phData.push(item?.water_ph)

      //Push water_ph to phData
      coolantData.push(item?.coolant_ph)
    });
  
    return {
      phLabels,
      phLowerLimit,
      phHigherLimit,
      phControlLine,
      phData,
      coolantData
    };
  }
  
  